import {
  icons_exports
} from "./chunk-SWSTXSFC.js";
import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/ui/icon/index.tsx
import React, { lazy, Suspense } from "react";
import { cva } from "class-variance-authority";
import dynamicIconImports from "lucide-react/dynamicIconImports";
import { jsx } from "react/jsx-runtime";
var iconVariants = cva("inline-block aspect-square", {
  variants: {
    size: {
      sm: "h-3 w-3",
      md: "h-4 w-4",
      lg: "h-5 w-5",
      xl: "h-6 w-6"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var iconCache = {};
var LucideIcon = React.memo(({ name, className, size, ...props }) => {
  let LazyIcon = iconCache[name];
  if (!LazyIcon) {
    LazyIcon = lazy(dynamicIconImports[name]);
    iconCache[name] = LazyIcon;
  }
  return /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx("span", { className: cn(iconVariants({ size }), className) }), children: /* @__PURE__ */ jsx(LazyIcon, { className: cn(iconVariants({ size }), className), ...props }) });
});
LucideIcon.displayName = "LucideIcon";
var Icon = React.memo(({ name, custom, className, size, ...props }) => {
  if (custom) {
    let CustomIconComponent;
    if (typeof custom === "string") {
      CustomIconComponent = icons_exports[custom];
    } else {
      CustomIconComponent = custom;
    }
    if (CustomIconComponent) {
      return /* @__PURE__ */ jsx(
        CustomIconComponent,
        {
          className: cn(iconVariants({ size }), className),
          ...props
        }
      );
    }
  }
  if (name) {
    return /* @__PURE__ */ jsx(LucideIcon, { name, className, size, ...props });
  }
  return null;
});
Icon.displayName = "Icon";

export {
  iconVariants,
  Icon
};
//# sourceMappingURL=chunk-7IEFGXFA.js.map